module.exports = __webpack_public_path__ + "71422c67f17c8c15a2b5e1b6358405dc.svg";